<template>
  <!-- 遮罩层：不透明 + opacity，避免 GPU 退化 -->
  <div
    class="hp-mask"
    v-show="showVisible"
    @touchstart.prevent="onMaskTouch"
    @click="onMaskClick"
  ></div>

  <!-- 弹窗容器 -->
  <div
    class="hp-wrapper"
    v-show="showVisible"
  >
    <div class="hp-popup" :style="{ height: showHeight }">
      <slot />
      <div class="hp-close" @touchstart.prevent="onCloseTouch" @click="onCloseClick">
        ✕
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch } from 'vue'
import { isTouchDevice } from '@/utils/tap'

const props = defineProps({
  showVisible: Boolean,
  showHeight: {
    type: String,
    default: '33rem'
  }
})

const emit = defineEmits(['update:showVisible','cancel'])

// 弹窗刚打开的这段时间内忽略关闭操作：
// 部分机型同一次触摸会在弹窗显示后再补发 touchstart / click，落到遮罩上会导致弹窗一闪就关（表现为“点了不弹出”）
const OPEN_GUARD_MS = 400
const GHOST_CLICK_MS = 700
let openedAt = 0
let lastCloseTouchAt = 0

watch(() => props.showVisible, (val) => {
  if (val) openedAt = Date.now()
})

const close = () => {
  if (Date.now() - openedAt < OPEN_GUARD_MS) return
  emit('update:showVisible', false)
  emit('cancel')
}

// 触摸关闭
const onMaskTouch = () => {
  lastCloseTouchAt = Date.now()
  close()
}
const onCloseTouch = onMaskTouch

// click 兜底：只有 touchstart 完全不生效的机型才会真正执行
// 支持触摸的机型一律不走 click，否则长按后补发的合成 click 会把刚打开的弹窗关掉
const closeByClick = () => {
  if (isTouchDevice()) return
  if (Date.now() - lastCloseTouchAt < GHOST_CLICK_MS) return
  close()
}
const onMaskClick = closeByClick
const onCloseClick = closeByClick
</script>

<style scoped>
/* 遮罩层：单独一层，不用 rgba */
/* 注意：不要用 inset 简写，低版本 WebView(Chromium < 87) 不支持，会导致遮罩/弹窗塌陷到屏幕外 */
.hp-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  opacity: 0.6;
  z-index: 999;
  touch-action: none;
}

/* 弹窗包裹层：铺满屏幕，内部用绝对定位居中（兼容老内核，见 README 10.3） */
.hp-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  pointer-events: auto;
}

/* 弹窗主体 */
.hp-popup {
  width: 28rem;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 1rem;
  padding: 1rem;
  pointer-events: auto;
}

/* 关闭按钮 */
.hp-close {
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  font-size: 2rem;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
}
</style>
